import React from "react";
import './Body7.css';
import {Link} from "react-router-dom"
import picture203 from './source/picture203.png'
import picture201 from './source/picture201.png'
import picture202 from './source/picture202.png'




function Body7() {

  return (
    <div className="body7">
      <div className="body7-box1">
        <div className="body7-box2">
          <div className="body7-box3">Kudlovice</div>
          <div className="body7-box5"><div className="body7-box4"></div></div>
          <div className="body7-box6">
          <img className="body7-box6-picture" src={picture203} alt="picture1"/>
          <img className="body7-box6-picture" src={picture201} alt="picture1"/>
          <img className="body7-box6-picture2" src={picture202} alt="picture1"/>
          </div>
          <div className="body7-box8"><div className="body7-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body7;
